<template>
    <div class="loading-spinner"></div>
</template>

<script>
export default {
    name: 'LoadingSpinner'
}
</script>

<style lang="scss" scoped>
.loading-spinner {
    width: 24px;
    height: 24px;
    border: 3px solid rgba(75, 75, 75, 0.3);
    border-radius: 50%;
    border-top-color: #1da1f2;
    animation: spin 1s linear infinite;
    margin-bottom: 10px;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
</style>
